import { getErrorMessage } from "../utils/commonUtils";
import {
  useCreateApprovalWorkflowMutation,
  useDeleteApprovalWorkflowMutation,
  useEditApprovalWorkflowMutation,
  useGetApprovalWorkflowByIdMutation,
  useGetApprovalWorkflowsMutation,
  useGetApprovalModesMutation,
  useDuplicateApprovalWorkflowMutation,
  usePostApprovalWorkflowMutation,
  usePostApproverDetailMutation,
  usePutApproverDetailMutation,
} from "../redux/approvalWorkflow/approvalWorkflowApiSlice";
import { toast } from "react-toastify";

export default function useApprovalWorkflow() {
  const [getApprovalWorkflows, { isLoading: getApprovalWorkflowsLoading }] =
    useGetApprovalWorkflowsMutation();
  const [createApprovalWorkflow, { isLoading: createApprovalWorkflowLoading }] =
    useCreateApprovalWorkflowMutation();
  const [editApprovalWorkflow, { isLoading: editApprovalWorkflowLoading }] =
    useEditApprovalWorkflowMutation();
  const [deleteApprovalWorkflow, { isLoading: deleteApprovalWorkflowLoading }] =
    useDeleteApprovalWorkflowMutation();
  const [getApprovalWorkflowById, { isLoading: getApprovalWorkflowByIdLoading }] =
    useGetApprovalWorkflowByIdMutation();
  const [getApprovalModes, { isLoading: getApprovalModesLoading }] =
    useGetApprovalModesMutation();
  const [duplicateApprovalWorkflow, { isLoading: duplicateApprovalWorkflowLoading }] =
    useDuplicateApprovalWorkflowMutation();
  const [postApprovalWorkflow, { isLoading: postApprovalWorkflowLoading }] =
    usePostApprovalWorkflowMutation();
  const [postApproverDetail, { isLoading: postApproverDetailLoading }] =
    usePostApproverDetailMutation();
  const [putApproverDetail, { isLoading: putApproverDetailLoading }] =
    usePutApproverDetailMutation();

  const getApprovalWorkflowsAPI = async (data: any) => {
    try {
      const response: any = await getApprovalWorkflows(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getApprovalWorkflowByIdAPI = async (data: any) => {
    try {
      const response: any = await getApprovalWorkflowById(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const createApprovalWorkflowAPI = async (data: any) => {
    try {
      const response: any = await createApprovalWorkflow(data).unwrap();
      toast.success("Success! Approval Workflow has been Created.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const editApprovalWorkflowAPI = async (data: any) => {
    try {
      const response: any = await editApprovalWorkflow(data).unwrap();
      toast.success("Success! Approval Workflow has been Updated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const deleteApprovalWorkflowAPI = async (data: any) => {
    try {
      const response: any = await deleteApprovalWorkflow(data).unwrap();
      toast.success("Success! Approval Workflow has been Deleted.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const getApprovalModesAPI = async () => {
    try {
      const response: any = await getApprovalModes({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const duplicateApprovalWorkflowAPI = async (data: any) => {
    try {
      const response: any = await duplicateApprovalWorkflow(data).unwrap();
      toast.success("Success! Approval Workflow has been Duplicated.");
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postApprovalWorkflowAPI = async (data: any) => {
    try {
      const response: any = await postApprovalWorkflow(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const postApproverDetailAPI = async (data: any) => {
    try {
      const response: any = await postApproverDetail(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  const putApproverDetailAPI = async (data: any) => {
    try {
      const response: any = await putApproverDetail(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  return {
    getApprovalWorkflowsAPI,
    getApprovalWorkflowsLoading,
    createApprovalWorkflowAPI,
    createApprovalWorkflowLoading,
    editApprovalWorkflowAPI,
    editApprovalWorkflowLoading,
    deleteApprovalWorkflowAPI,
    deleteApprovalWorkflowLoading,
    getApprovalWorkflowByIdAPI,
    getApprovalWorkflowByIdLoading,
    getApprovalModesAPI,
    getApprovalModesLoading,
    duplicateApprovalWorkflowAPI,
    duplicateApprovalWorkflowLoading,
    postApprovalWorkflowAPI,
    postApprovalWorkflowLoading,
    postApproverDetailAPI,
    postApproverDetailLoading,
    putApproverDetailAPI,
    putApproverDetailLoading,
  };
}
